import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';
import { NotificationState } from './notification.reducer';

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class NotificationActions {
    static webSocketUnreadTwoWayMessagesPushed =
        createAction('[WebSocket] WebSocket Unread TwoWay Messages Pushed', props<NotificationState>());

    static startSyncUnreadTwoWayMessages =
        createAction('[NavBar:TwoWayUnread] Start Sync of TwoWay Messages from Backend');

    static stopSyncUnreadTwoWayMessages =
        createAction('[NavBar:TwoWayUnread] Stop Sync of TwoWay Messages from Backend');
}
